import styles from './ProcessingIndicator.module.css';

import wordIcon from '@/assets/applications/WordIcon.svg';
import adobeIcon from '@/assets/applications/AdobeIcon.svg';
import outlookIcon from '@/assets/applications/OutlookIcon.svg';
import powerpointIcon from '@/assets/applications/PowerpointIcon.svg';
import excelIcon from '@/assets/applications/ExcelIcon.svg';
import zoomIcon from '@/assets/applications/ZoomIcon.svg';
import chromeIcon from '@/assets/applications/ChromeIcon.svg';
import teamsIcon from '@/assets/applications/TeamsIcon.svg';
import calendarIcon from '@/assets/applications/CalendarIcon.svg';
import kofaxIcon from '@/assets/applications/KofaxIcon.svg';
import photosIcon from '@/assets/applications/WindowsPhotos.svg';
import foxitIcon from '@/assets/applications/FoxitIcon.svg';

interface ProcessingIndicatorProps {
  show: boolean;
  message?: string;
  application?: string | null;
}

const ProcessingIndicator: React.FC<ProcessingIndicatorProps> = ({
  show,
  message = "Processing entry...",
  application
}) => {
  if (!show) return null;

  const getApplicationIcon = (appName: string | null): string | null => {
    if (!appName) return null;
    
    const appLower = appName.toLowerCase();
    
    if (appLower.includes('word')) return wordIcon;
    if (appLower.includes('adobe') || appLower.includes('acrobat')) return adobeIcon;
    if (appLower.includes('outlook')) return outlookIcon;
    if (appLower.includes('powerpnt')) return powerpointIcon;
    if (appLower.includes('excel')) return excelIcon;
    if (appLower.includes('zoom')) return zoomIcon;
    if (appLower.includes('chrome')) return chromeIcon;
    if (appLower.includes('teams')) return teamsIcon;
    if (appLower.includes('calendar')) return calendarIcon;
    if (appLower.includes('powerpdf') || appLower.includes('kofax')) return kofaxIcon;
    if (appLower.includes('photos')) return photosIcon;
    if (appLower.includes('foxit')) return foxitIcon;

    return null;
  };

  const appIcon = getApplicationIcon(application ?? null);

  return (
    <div className={styles.processingIndicator}>
      <div className={styles.content}>
        <div className={styles.spinner}></div>
        {appIcon && (
          <img
            src={appIcon}
            alt={`${application} icon`}
            className={styles.appIcon}
          />
        )}
        <span className={styles.message}>{message}</span>
      </div>
    </div>
  );
};

export default ProcessingIndicator;